import {
    Module,
    VuexModule,
    Mutation,
    getModule,
} from 'vuex-module-decorators';

import store from '@/store';

export interface IGalleryStore {
    IMAGES: readonly string[];
    ACTIVE_INDEX: number;
    SHOW_MODAL: boolean;
    SET_IMAGES: (data: string[]) => void;
    SET_ACTIVE_INDEX: (index: number) => void;
    SET_SHOW_MODAL: (state: boolean) => void;
}

@Module({
    dynamic: true,
    store,
    name: 'galleryStore',
})
class Gallery extends VuexModule implements IGalleryStore {
    private images: string[] = [];
    private activeIndex = 0;
    private showModal = false;

    get ACTIVE_INDEX() {
        return this.activeIndex;
    }

    get IMAGES() {
        return this.images;
    }

    get SHOW_MODAL() {
        return this.showModal;
    }

    @Mutation
    SET_IMAGES(images: string[]) {
        this.images = images;
    }

    @Mutation
    SET_ACTIVE_INDEX(index: number) {
        this.activeIndex = index;
    }

    @Mutation
    SET_SHOW_MODAL(state: boolean) {
        this.showModal = state;
    }

    @Mutation
    RESET_DATA() {
        this.images = [];
        this.activeIndex = 0;
        this.showModal = false;
    }
}

export const galleryStore = getModule(Gallery);
